import { createContainer, createHook, createStore } from 'react-sweet-state';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
export const actions = {
  load: projectId => ({
    getState,
    setState
  }, {
    apiUtil
  }) => {
    if (!getState().loading) {
      setState({
        data: undefined,
        error: undefined,
        loading: true
      });
      apiUtil.get(`/api/cloud/createissue/project/${projectId}/forms`).then(formDetails => {
        if (getBooleanFF('platform.jsm-rt-security-issue-forms')) {
          setState({
            data: formDetails.filter(detail => detail.canCreateNewIssue === true || detail.canCreateNewIssue === undefined)
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .map(({
              canCreateNewIssue,
              ...formDetail
            }) => formDetail),
            loading: false
          });
        } else {
          setState({
            data: formDetails,
            loading: false
          });
        }
      }).catch(apiError => {
        setState({
          error: apiError,
          loading: false
        });
      });
    }
  }
};
const Store = createStore({
  initialState: {
    data: undefined,
    error: undefined,
    loading: false
  },
  actions,
  name: 'ProjectFormsService'
});
export const ProjectFormsServiceContainer = createContainer(Store);
export const useProjectFormsService = createHook(Store);